<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.smAndUp"
    app
    :color="tbColor"
    dark flat style="border-bottom: 1px solid #111 !important"
  >
    <v-toolbar-title class="headline" style="width: 240px; margin-left: 0px">
      <span>schools</span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-progress-circular v-if="inAction" indeterminate size="20" color="secondary" class="mx-3"></v-progress-circular>
    <v-card flat dark class="py-1 px-2 darkligth" v-if="profile">
      {{profile.schooladminid}}
      <v-icon small>vpn_key</v-icon>
      {{profile.schoolid}}
    </v-card>

    <v-btn color="secondary" text v-if="(ready === true) && !profile" href="#/login">Войти</v-btn>
    <v-btn color="secondary" text v-if="profile" @click="$store.dispatch('logout')" icon>
      <v-icon>logout</v-icon>
    </v-btn>

  </v-app-bar>
</template>

<script>
export default {
  name: 'ToolbarMenu',
  data: () => ({
    search: null,
    tbColor: '#0f6366',
  }),
  methods: {
  },
  computed: {
    ready () {
      return this.$store.state.ready
    },
    profile () {
      return this.$store.state.profile
    },
    inAction () {
      return this.$store.state.tasksInAction > 0
    },
  }
}
</script>

<style lang="css">
</style>
